'use client';

import { useEffect } from 'react';

/**
 * Composant pour nettoyer les attributs ajoutés par les extensions de navigateur
 * qui causent des avertissements de hydration React
 */
export function CleanupExtensionAttributes() {
  useEffect(() => {
    // Liste des attributs communs ajoutés par les extensions
    const extensionAttributes = ['cz-shortcut-listen', 'data-new-gr-c-s-check-loaded', 'data-gr-ext-installed'];
    
    const cleanup = () => {
      // Nettoyer sur body
      if (typeof document !== 'undefined') {
        const body = document.body;
        if (body) {
          extensionAttributes.forEach(attr => {
            if (body.hasAttribute(attr)) {
              body.removeAttribute(attr);
            }
          });
        }
        
        // Nettoyer sur html
        const html = document.documentElement;
        if (html) {
          extensionAttributes.forEach(attr => {
            if (html.hasAttribute(attr)) {
              html.removeAttribute(attr);
            }
          });
        }
      }
    };

    // Nettoyer immédiatement
    cleanup();
    
    // Nettoyer après un court délai pour s'assurer que l'extension a fini
    const timeout = setTimeout(cleanup, 100);
    
    // Observer les mutations pour nettoyer si l'extension ré-ajoute l'attribut
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes') {
          const target = mutation.target as HTMLElement;
          extensionAttributes.forEach(attr => {
            if (target.hasAttribute(attr)) {
              target.removeAttribute(attr);
            }
          });
        }
      });
    });

    if (typeof document !== 'undefined') {
      observer.observe(document.body, {
        attributes: true,
        attributeFilter: extensionAttributes,
      });
      
      observer.observe(document.documentElement, {
        attributes: true,
        attributeFilter: extensionAttributes,
      });
    }

    return () => {
      clearTimeout(timeout);
      observer.disconnect();
    };
  }, []);

  return null;
}

